<template>
    <div class="margin">
        <content-item-container :showWord="true">
            <div class="reward-first">
                <div class="title-box">
                    <img class="reward-title" src="../../../assets/images/postalNewCustomer/reward_content_title_1.png">
                </div>
                <div class="img-box">
                    <img class="reward-img" src="../../../assets/images/postalNewCustomer/index_reward_first.png">
                    <div class="text-box-first" @click="instructionOpen(1)"></div>
                    <img class="icon-left" v-if="rewardFirst == 1" src="../../../assets/images/postalNewCustomer/icon_get.png" alt="">
                    <img class="icon-left" v-if="rewardFirst == 2" src="../../../assets/images/postalNewCustomer/icon_over.png" alt="">
                    <img class="icon-right" v-if="luckDrawType == 2" src="../../../assets/images/postalNewCustomer/icon_over.png" alt="">
                    <img class="icon-right" v-if="luckDrawType == 1" src="../../../assets/images/postalNewCustomer/icon_get.png" alt="">
                </div>
            </div>
        </content-item-container>
    </div>
</template>

<script>
import contentItemContainer from './ContentItemContainer.vue'
export default {
    components: { contentItemContainer },
    props: {
        //抽奖次数状态
        luckDrawType: {
            type: [Number, String],
            default: 0
        },
        //报名红包状态
        rewardFirst: {
            type: [Number, String],
            default: 0
        },
    },
    data() {
        return {

        }
    },
    computed: {},
    created() { },
    mounted() { },
    beforeDestroy() { },
    methods: {
        instructionOpen(num) {
            this.$emit('instructionOpen', num)
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./function";
.margin {
    margin-bottom: pxvw(20);
}
.reward-first {
    // padding: pxvw(32) pxvw(21) pxvw(40) pxvw(21);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: pxvw(32) 0;
    .title-box {
        width: pxvw(625);
    }
    .img-box {
        position: relative;
        .text-box-first {
            bottom: pxvw(66);
            left: pxvw(114);
            position: absolute;
            width: pxvw(82);
            height: pxvw(22);
            // background: rgba(0, 0, 0, 0.5);
        }
        .icon-left {
            position: absolute;
            top: pxvw(-21);
            left: pxvw(199);
            width: pxvw(123);
            height: pxvw(123);
        }
        .icon-right {
            position: absolute;
            top: pxvw(-21);
            right: pxvw(-15);
            width: pxvw(123);
            height: pxvw(123);
        }
    }
    .reward-img {
        width: pxvw(625);
        margin-top: pxvw(19);
    }
    .reward-title {
        font-size: 0;
        height: pxvw(68);
    }
}
</style>